
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import LayoutContainer from './Layout/LayoutContainer';
import { ClientStyles } from "./Styles/ClientStyles";


function App() {
  return (
    <div >
      <LayoutContainer/>
    </div>
  );
}

export default App;
